export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";